import { createWebHistory, createRouter } from "vue-router";
import NotFoundSection from "@/components/NotFoundSection.vue";
import AcreditadoSection from "@/components/AcreditadoSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import CredencialExpositorSection from "@/components/CredencialExpositorSection.vue";
import ExpositorSection from "@/components/ExpositorSection.vue";

const routes = [
  {
    path: "/",
    component: AcreditadoSection,
  },
  {
    path: "/expositores",
    component: ExpositorSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/credencialesExpositores",
    component: CredencialExpositorSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import { createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;